import BaseModelAPI from '../BaseModelAPI';

export default class StockOpname extends BaseModelAPI {
	static entity = 'stockopname';
	static entityName = 'stockopname';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockOpnamePlanId = '';
			this.stockOpnamePlan = {};
			this.areaStoId = '';
			this.areaSto = {};
			this.vendorSubconId = '';
			this.vendorSubcon = {};
			this.idCard = '';
			this.totalCaseArea = 0;
			this.totalCaseActual = 0;
			this.stockOpnameStatusId = '';
			this.stockOpnameStatus = {};
			this.stockOpnameDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.stockOpnameLabelCombo = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}
	static async getInprogressStockOpname(this_,id){
		return this_.$http.get(`${this.entityName}/getinprogressstockopname/`+id)
		.then(async function(response){
			let responseData = response.data;
            return responseData;
		})
		.catch(function(error){
			
			var stringError = 'Gagal melakukan melakukan stock opname !';
			if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
				let errorList = Object.values(error.response.data.errors);
				const errorObj = errorList.find(() => true);
				stringError =errorObj[0];
			}
			this_.toast({message: stringError, title:'Error', variant : 'danger'});
            throw error;
        });
	}
    static async nextScanCase(this_, idSto, data ) {
        return this_.$http.put(`${this.entityName}/nextscancase/${idSto}`, data)
        .then(response => {
            return response.data;
        })
        .catch(function(error){
			var stringError = 'Gagal melakukan Next Scan case !';
			if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
				let errorList = Object.values(error.response.data.errors);
				const errorObj = errorList.find(() => true);
				stringError =errorObj[0];
			}
			this_.toast({message: stringError, title:'Error', variant : 'danger'});
            throw error;
        });
    }

}